import { css } from '@linaria/atomic';
import { breakpoints } from '@frontend/responsiveness';

export const styles = {
  container: css`
    border: 1px solid var(--fpb-border, var(--fabric-color-accent-seaweed-base));
    border-radius: var(--fabric-number-n-4-px);
    display: flex;
    flex-direction: column;
    box-shadow: var(--fabric-card-shadow);
    box-sizing: border-box;
    container-type: inline-size;
    position: relative;
    overflow: hidden;
    background-color: var(--fabric-color-surface-default);
  `,
  header: css`
    display: flex;
    align-items: center;
    gap: var(--fabric-space-gap-xs);
    padding: var(--fabric-space-padding-md);
    background-color: var(--fpb-header-bg, var(--fabric-color-accent-seaweed-alpha-subtle));
  `,
  headerLeading: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  `,
  headerTitle: css`
    line-height: 1.2;
    margin: 0;
  `,
  body: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--fabric-space-padding-md);
    gap: var(--fabric-space-gap-md);
    background-color: var(--fabric-color-surface-default);
  `,
  content: css`
    display: flex;
    flex-direction: column;
    gap: var(--fabric-space-gap-md);
    max-width: 55cqi;
    z-index: 1;

    @container (max-width: 834px) {
      max-width: 100%;
    }
  `,
  contentFullWidth: css`
    max-width: 100%;
  `,
  title: css`
    line-height: 1.3;
  `,
  description: css`
    line-height: 1.4;
    color: var(--fabric-color-text-secondary);
  `,
  highlights: css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  `,
  highlightsBullets: css`
    gap: var(--fabric-space-gap-xs);
  `,
  highlightsNoBullets: css`
    gap: var(--fabric-space-gap-md);
  `,
  highlightItem: css`
    display: inline-flex;
    align-items: center;
    gap: var(--fabric-space-gap-xxs);
  `,
  highlightIcon: css`
    color: var(--fpb-icon, var(--fabric-color-accent-seaweed-base));
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  `,
  highlightIconBackground: css`
    padding: 2px;
    border-radius: var(--fabric-number-n-1-px);
    background-color: var(--fpb-header-bg, var(--fabric-color-accent-seaweed-alpha-subtle));
  `,
  bullet: css`
    color: var(--fabric-color-text-subtle);
    font-weight: bold;
    user-select: none;
    margin: 0 var(--fabric-space-gap-xxs);

    @container (max-width: ${breakpoints.small.min}px) {
      display: none;
    }
  `,
  actions: css`
    display: flex;
    align-items: center;
    gap: var(--fabric-space-gap-sm);
    flex-wrap: wrap;

    @container (max-width: ${breakpoints.small.min}px) {
      flex-direction: column;
      align-items: stretch;
    }
  `,
  dismissButton: css`
    color: var(--fabric-color-text-secondary);

    &:hover {
      color: var(--fabric-color-text-primary);
    }
  `,
  mediaOverlay: css`
    position: absolute;
    top: 16px;
    right: 16px;
    bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    overflow: hidden;
  `,
  mediaInline: css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    z-index: 1;
    overflow: hidden;
  `,
  mediaRounded: css`
    border-radius: var(--fabric-number-n-3-px);
  `,
  mediaHideLg: css`
    @container (max-width: 834px) {
      display: none;
    }
  `,
  mediaHideMd: css`
    @container (max-width: 744px) {
      display: none;
    }
  `,
  mediaHideSm: css`
    @container (max-width: 530px) {
      display: none;
    }
  `,
};
